// extracted by mini-css-extract-plugin
module.exports = {"DefaultTheme__tabpanel___pazLR":"DefaultTheme__tabpanel___pazLR","DefaultTheme__active___2xepg":"DefaultTheme__active___2xepg"};